import type { CustomToken } from '@passkeys/assets';

import type { Assets, Asset } from '@/types';

type ToAssetParams = {
  assets: Assets;
  token: CustomToken;
};

export function toAsset({ assets, token }: ToAssetParams): Asset {
  const baseAsset = token.baseAsset ?? assets[token.baseAssetName];

  let asset: Asset | undefined = assets[token.name];
  if (asset) {
    return asset;
  }

  let tokenId = token.assetId;
  const isEvmToken = tokenId?.startsWith('0x');
  if (isEvmToken) {
    tokenId = tokenId?.toLowerCase();
  }

  asset = Object.values(assets).find((entry) => {
    let assetId = entry.assetId;
    if (isEvmToken) {
      assetId = assetId?.toLowerCase();
    }

    return baseAsset.name === entry.baseAssetName && assetId === tokenId;
  });
  if (asset) {
    return asset;
  }

  return {
    ...token,
    baseAsset,
    isCustomToken: !token.isBuiltIn,
    displayNetworkTicker:
      token.displayNetworkTicker ?? baseAsset.displayNetworkTicker,
  } as Asset;
}
